import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  shouldRefreshRecently: true,
  appEndorsementStatus: "completed",
};

const flagSlice = createSlice({
  name: "changeFlag",
  initialState,
  reducers: {
    changeFlag(state, action) {
      state.shouldRefreshRecently = action.payload;
    },
    changeAppEndorsementStatus(state, action) {
      state.appEndorsementStatus = action.payload;
    },
  },
});

export const { changeFlag, changeAppEndorsementStatus } = flagSlice.actions;
export default flagSlice.reducer;
